import { render } from "./EcosystemPage.vue?vue&type=template&id=5c0f5a5e"
import script from "./EcosystemPage.vue?vue&type=script&lang=js"
export * from "./EcosystemPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__